import React from 'react';

import { ReactComponent as ErrorIcon } from '../../../assets/images/svg/error-icon.svg';
import { ReactComponent as SuccessIcon } from '../../../assets/images/svg/success-bounce.svg';

const MessageModal = ({ message, close, type, title }) => {
    const success = 'Successful!';
    const error = 'Oops Error!';

    return (
        <React.Fragment>
            <div className={`${message ? 'oi-error--mod' : ''} oi-error`}>
                <div className={`${message ? 'oi-error__container--mod ' : ''} oi-error__container`}>
                    <div className="oi-error__icon-wrapper">{type === 'success' ? <SuccessIcon /> : <ErrorIcon />}</div>

                    <div className="oi-error__msg">
                        <div className="oi-error__msg-header">{type === 'success' ? success : error}</div>

                        <div className="oi-error__msg-text">{message}</div>
                    </div>

                    <button
                        onClick={close}
                        className={`${type === 'success' ? 'green-btn' : ''} oi-error__close-btn`}
                        type="button">
                        {title ? title : "Close"}
                    </button>
                </div>
            </div>
            {/* <button onClick={this.showModal} type="button">Open</button> */}
        </React.Fragment>
    );
};

export default MessageModal;
